import { render, staticRenderFns } from "./ProfileStep2.vue?vue&type=template&id=07b1ab01&"
import script from "./ProfileStep2.vue?vue&type=script&lang=js&"
export * from "./ProfileStep2.vue?vue&type=script&lang=js&"
import style0 from "./ProfileStep2.vue?vue&type=style&index=0&id=07b1ab01&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports